import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import FormHeader from "../../../Common/components/templates/formHeader";
import FormDirections from "../../../Common/components/templates/formDirections"
import PrimaryButton from "../../../Common/components/templates/buttons/primary";
import { FormattedMessage, useIntl } from "react-intl";
import { getLocale } from "../../../Common/localization/localizationHelper";

const ResetMfa = (props: any) => {
    const history = useHistory();
    const [email] = useState("");

    const handleButtonClick = () => {
        const locale = getLocale();
        let search;
        if (locale) {
            search = `?ui_locales=${locale}`;
        }
        history.push({
            pathname: '/emailsent',
            search
        }, { email });
    };

    return (
        <form className="form">
            <FormHeader title={useIntl()?.messages["mfa.resetmfa.header"]} />
            <div className="content">
                <FormDirections>
                    <FormattedMessage id="mfa.resetmfa.body"></FormattedMessage>
                </FormDirections>
                <div className="buttons-reset-mfa">
                    <PrimaryButton
                        variant="contained"
                        color="primary"
                        onClick={handleButtonClick}
                    >
                        <FormattedMessage id="mfa.resetmfa.button.sendEmail"></FormattedMessage>
                    </PrimaryButton>
                </div>
            </div>
        </form>
    );
};

export default ResetMfa;
